/**
 * ColorPickerHandle  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { useDrag } from "../../hooks/useDrag";

export interface IColorPickerHandleProps {
	className?: string;
}

export const ColorPickerHandle: React.FC<IColorPickerHandleProps> = React.memo(({ className }) => {
	const baseClass = BEM("edt-color-picker-handle");
	const { startDragging } = useDrag({}, { preventTextSelection: true });

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()} onMouseDown={startDragging} />;
});
